import React from "react";
import { useLanguage } from "../contexts/LanguageProvider";
import { CONTACT_INFO, ACCESSIBILITY_OVERLAYS_ENABLED } from "../config/constants";
import anoViannosBackground from "../assets/ano-viannos-background.jpg";

export default function About() {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center">
        <div className="absolute inset-0 z-0">
          <img
            src={anoViannosBackground}
            alt="Ano Viannos village"
            className="w-full h-full object-cover"
          />
          <div className={`absolute inset-0 ${ACCESSIBILITY_OVERLAYS_ENABLED ? 'bg-gradient-to-r from-gray-900/70 to-gray-800/50' : 'bg-gradient-to-r from-gray-900/35 to-gray-800/25'}`}></div>
        </div>

        <div className="relative z-10 text-center text-white max-w-4xl mx-auto px-4">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 tracking-tight px-6 py-2 rounded-lg inline-block bg-black/60">
            {t('aboutHeroTitle')}
          </h1>
          <p className="text-xl md:text-2xl text-white max-w-2xl mx-auto leading-relaxed px-6 py-3 rounded-lg font-semibold bg-black/50">
            {t('aboutHeroSubtitle')}
          </p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Main Story Section */}
        <div className="mb-20">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold text-gray-900 mb-12 text-center">{t('aboutStoryTitle')}</h2>
            <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
              <p className="text-xl leading-relaxed">
                {t('storyParagraph1')}
              </p>
              <p>
                {t('storyParagraph2')}
              </p>
              <p>
                {t('storyParagraph3')}
              </p>
              <p>
                {t('storyParagraph4')}
              </p>
              <p>
                {t('storyParagraph5')}
              </p>
              <p>
                {t('storyParagraph6')}
              </p>
              <p className="text-lg font-medium text-gray-800 bg-blue-50 p-6 rounded-xl border-l-4 border-blue-500">
                {t('storyParagraph7')}
                <a 
                  href={t('storyParagraph7LinkUrl')} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:text-blue-800 underline font-semibold"
                >
                  {t('storyParagraph7Link')}
                </a>.
              </p>
            </div>
          </div>
        </div>


        {/* Contact CTA */}
        <section className="text-center py-16 bg-gradient-to-r from-blue-900 to-blue-800 rounded-3xl">
          <div className="text-white">
            <h2 className="text-4xl font-bold mb-6">{t('aboutCtaTitle')}</h2>
            <p className="text-xl mb-8 text-blue-100 max-w-2xl mx-auto">
              {t('aboutCtaSubtitle')}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center px-4">
              <a
                href={`tel:${CONTACT_INFO.PHONE}`}
                className="px-6 py-4 bg-white text-blue-900 rounded-lg font-semibold hover:bg-blue-50 transition-colors duration-300 text-center"
              >
                {t('aboutCtaCallUs')} {CONTACT_INFO.PHONE}
              </a>
              <a
                href={`mailto:${CONTACT_INFO.EMAIL}`}
                className="px-6 py-4 border-2 border-white text-white rounded-lg font-semibold hover:bg-white hover:text-blue-900 transition-colors duration-300 text-center"
              >
                {t('aboutCtaEmailUs')}
              </a>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
